export default __webpack_public_path__ + "static/media/Waterfall.c05458ac.mp4";